/* eslint-disable no-undef */
// userSaga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import { patientDetailsRequestSuccess, patientDetailsRequestError, familyTreeRequestSuccess, familyTreeRequestError, getCountriesRequestSuccess, getCountriesRequestError, addNewFamilyRequestSuccess, addNewFamilyRequestError, familyTreeRequest, updateFamilyMemberSuccess, updateFamilyMemberError } from './Actions';
import { ADD_NEW_FAMILY, FAMILY_TREE, GET_COUNTRIES, PATIENT_DETAILS, PROFILE_FAMILY_GET, DELETE_FAMILY_MEMBER, DELETE_FAMILY_MEMBER_SUCCESS, DELETE_FAMILY_MEMBER_ERROR, UPDATE_FAMILY_MEMBER } from './Constant';
import axios from 'axios';
import dayjs from 'dayjs';
import { Modal } from 'antd';
import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

function* PatientDetails(action) {

    try {    
        // Use action.payload if provided (for fetching specific member for edit),
        // otherwise, use the existing localStorage item (for default profile view context)
        const patientIdToFetch = action.payload || localStorage.getItem('FAMILY_PATIENT_ID');

        const url = `${process.env.REACT_APP_API_BASE_URL}/patients/${patientIdToFetch}`;
  
        // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            limit: 1000,
            skip: 0,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  

        const response = yield call(axios.get, url,{ headers});

        // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            // Dispatch the success action with data and message      
            yield put(patientDetailsRequestSuccess(response.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(patientDetailsRequestError('An error occurred.'));
        }

    } catch (error) {
        yield put(patientDetailsRequestError('An error occurred.'));
    // throw error;
    // yield put(fetchUserFailure(error));
    }

}

function* FamilyTreeDetails() {

    try {    

        const patientId = localStorage.getItem('FAMILY_PATIENT_ID');
        const url = `${process.env.REACT_APP_API_BASE_URL}/familydetails?parentId=${patientId}`;
  
        // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            limit: 1000,
            skip: 0,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  

        const response = yield call(axios.get, url,{ headers});

        if (response.status === 200 || response.status === 201) {
      
            yield put(familyTreeRequestSuccess(response.data));
        } else {
            yield put(familyTreeRequestError('An error occurred.'));
        }

    } catch (error) {
        yield put(familyTreeRequestError('An error occurred.'));
    }

}

function* profileFamilyDetails(payload) {

    try {        

        const patientId = payload.userId;
        const url = `${process.env.REACT_APP_API_BASE_URL}/patients/${patientId}`;
  
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            limit: 1000,
            skip: 0,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        const response = yield call(axios.get, url,{ headers});

        if (response.status === 200 || response.status === 201) {
            yield put(patientDetailsRequestSuccess(response.data));
        } else {
            yield put(patientDetailsRequestError('An error occurred.'));
        }

    } catch (error) {
        yield put(patientDetailsRequestError('An error occurred.'));
    }
}

function* getCountries() {

    try {        

        const url = `${process.env.REACT_APP_API_BASE_URL}/countries`;
  
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        const response = yield call(axios.get, url,{ headers});

        if (response.status === 200 || response.status === 201) {

            yield put(getCountriesRequestSuccess(response.data));
        } else {
            yield put(getCountriesRequestError('An error occurred.'));
        }

    } catch (error) {
        yield put(getCountriesRequestError('An error occurred.'));
    }

}


function* postFamilyTree(action) {

    try {        

        let isint;
        if (action.value.resident === 'India') {
            isint = false;
        } else {
            isint = true;
        }
        
        const url = `${process.env.REACT_APP_API_BASE_URL}/patients`;

        
        
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        
        const data = {
            usersId: Number(localStorage.getItem('PARENT_USERID')),
            primaryEmail: localStorage.getItem('PARENT_EMAIL'),
            primaryContact: localStorage.getItem('PARENT_PHONE'),
            parentId:  Number(localStorage.getItem('PARENT_PATIENT_ID')),
            bloodGroup: action.value.bloodGroup,
            initials: action.initials,
            isInternational: isint,
            firstName: action.value.firstName,
            lastName: action.value.lastName,
            gender: action.value.gender,
            dob: dayjs(action.value.dateOfBirth).format('YYYY-MM-DD'),
            address: action.value.address,
            nationality: action.value.Country,
            latitude: '+21.2412',
            longitude: '+12.2236',
            countryCode: localStorage.getItem('COUNTRY_CODE'),
            residentCountry: action.value.resident,
            relationShip: action.value.relationship,
            isParent: false,
            image: action.value.image
        };
        
  
        const response = yield call(axios.post, url, data, { headers});

        if (response.status === 200 || response.status === 201) {
            const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
            const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
            Modal.success({
                title: langdata.PatientRegistrationSuccess,
            });
            
            yield put(addNewFamilyRequestSuccess(response.data));
        } else {
            Modal.error({
                title: 'Registration Failed',
                content: response.data?.message || 'Could not add family member. Please try again.',
            });
            yield put(addNewFamilyRequestError('An error occurred.'));
        }

    } catch (error) {
        Modal.error({
            title: 'Registration Failed',
            content: error.response?.data?.message || 'An unexpected error occurred. Please try again.',
        });
        yield put(addNewFamilyRequestError('An error occurred.'));
    }

}

function* deleteFamilyMemberSaga(action) {
    try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/patients/${action.payload}`;
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const response = yield call(axios.delete, url, { headers });

        if (response.status === 200 || response.status === 204) {
            yield put({ type: DELETE_FAMILY_MEMBER_SUCCESS, payload: action.payload });
            yield put(familyTreeRequest());
        } else {
            yield put({ type: DELETE_FAMILY_MEMBER_ERROR, error: 'Failed to delete family member.' });
        }
    } catch (error) {
        yield put({ type: DELETE_FAMILY_MEMBER_ERROR, error: 'An error occurred while deleting the family member.' });
    }
}

function* updateFamilyMemberSaga(action) {
    try {
        const { data: memberData, memberId } = action.payload;
        const url = `${process.env.REACT_APP_API_BASE_URL}/patients/${memberId}`;
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
        const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

        // Construct the payload for the PUT request based on your API requirements
        // This assumes a similar structure to the POST request for adding a family member
        const payloadToUpdate = {
            // Assuming your API might expect parent/user IDs. Adjust if not needed for update.
            usersId: Number(localStorage.getItem('PARENT_USERID')),
            primaryEmail: localStorage.getItem('PARENT_EMAIL'),
            primaryContact: localStorage.getItem('PARENT_PHONE'),
            parentId:  Number(localStorage.getItem('PARENT_PATIENT_ID')),
            
            bloodGroup: memberData.bloodGroup,
            initials: memberData.initials, // Ensure initials are passed correctly
            isInternational: memberData.resident !== 'India', // Recalculate if needed
            firstName: memberData.firstName,
            lastName: memberData.lastName,
            gender: memberData.gender,
            dob: dayjs(memberData.dateOfBirth).format('YYYY-MM-DD'),
            address: memberData.address,
            nationality: memberData.Country,
            latitude: '+21.2412', // Keep or remove if not editable
            longitude: '+12.2236', // Keep or remove if not editable
            countryCode: localStorage.getItem('COUNTRY_CODE'), // May or may not be needed/editable
            residentCountry: memberData.resident,
            relationShip: memberData.relationship,
            isParent: false,
            // This likely shouldn't be changed via this form
        };

        const response = yield call(axios.patch, url, payloadToUpdate, { headers });

        if (response.status === 200 || response.status === 201) {
            
 
            if(action.payload.image.image) {

    
                const file = action.payload.image.image;
                const image = new FormData();
                image.append('uri', file);
                image.append('permissions', 'patient');
                image.append('id', memberId);
                const urlFile = `${process.env.REACT_APP_API_BASE_URL}/uploads`;
                    
                let data = image;
                // const headers = new Headers({
    
                //     Authorization: sessionStorage.jwt,
                //     'api-header-security': process.env.REACT_APP_API_HEADER_SECURITY,
                // });


    
                delete headers['Content-Type'];                
                
                const response = yield call(axios.post, urlFile, data, { headers});
                
                if(response.status == 200 || response.status == 201) {
                    Modal.success({
                        title: langdata.FamilyMemberUpdateSuccess,
                    });
                    yield put(familyTreeRequest());
                    yield put(updateFamilyMemberSuccess(response.data));
                    // if(action.payload.isPrimaryDetailsUpdated == true) {
                    //     Modal.warning({
                    //         title: 'Your profile changes has been send to admin for verification.',
                    //     });
                    // } else {
                    // Modal.success({
                    //     title: 'Profile updated successfully',
                    // });
                    // }
                    // yield put(updateFamilyMemberSuccess('success'));
    
                } 
                else {
                    Modal.error({
                        title: 'Update Failed',
                        content: response.data?.message || 'An error occurred during the update.',
                    });
                    yield put(updateFamilyMemberError(response.data?.message || 'Failed to update family member.'));
                }
            } else {


                Modal.success({
                    title: langdata.FamilyMemberUpdateSuccess,
                });
                yield put(updateFamilyMemberSuccess(response.data));
                yield put(familyTreeRequest()); // Refresh the family tree list
            }

            // yield put(patientDetailsRequest(memberId)); // Optionally refresh the specific member details if needed on the form page, though navigation usually occurs.
        } else {
            Modal.error({
                title: 'Update Failed',
                content: response.data?.message || 'An error occurred during the update.',
            });
            yield put(updateFamilyMemberError(response.data?.message || 'Failed to update family member.'));
        }
    } catch (error) {
        Modal.error({
            title: 'Update Failed',
            content: error.response?.data?.message || 'An error occurred while updating the family member.',
        });
        yield put(updateFamilyMemberError(error.response?.data?.message || 'An error occurred while updating the family member.'));
    }
}

// Watcher Saga
export function* watchFetchFamilyTree() {
    yield takeEvery(PATIENT_DETAILS, PatientDetails);
    yield takeEvery(FAMILY_TREE, FamilyTreeDetails);
    yield takeEvery(PROFILE_FAMILY_GET, profileFamilyDetails);
    yield takeEvery(GET_COUNTRIES, getCountries);
    yield takeEvery(ADD_NEW_FAMILY, postFamilyTree);
    yield takeEvery(DELETE_FAMILY_MEMBER, deleteFamilyMemberSaga);
    yield takeEvery(UPDATE_FAMILY_MEMBER, updateFamilyMemberSaga);
}